import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { NavigationBar } from "./components";
import {
  Home,
  Services,
  Contact,
  ITPPage,
  ReservationPage,
  PortfolioPage,
  NotFoundPage,
} from "./pages";
import { Toaster } from "react-hot-toast";
import React, { Suspense } from "react";
const ReservationsPage = React.lazy(() => import("./pages/reservations"));

const App = () => {
  return (
    <Router>
      <Toaster />
      <div className="min-h-screen bg-gray-50 overscroll-none">
        <NavigationBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/itp" element={<ITPPage />} />
          <Route path="/portofoliu" element={<PortfolioPage />} />
          <Route path="/servicii" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/rezervare" element={<ReservationPage />} />
          <Route
            path="/rezervari"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ReservationsPage />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
